<template>
  <div class="container-scroller">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth">
        <div class="row flex-grow">
          <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left p-5">
              <div class="brand-logo">
                <img src="../../assets/images/maxcess-logo.png" />
              </div>
              <h4>Reset Password</h4>

              <label
                class="form-check-label text-muted"
                style="font-size: 0.8rem"
                >Enter new password. Your new password must be different from
                previously used password.
              </label>

              <BForm @submit.prevent="resetPassword" class="pt-3">
                <BForm>
                  <div class="row">
                    <div class="form-group">
                      <label for="exampleInputPassword4"
                        >Password<span class="mandatory-sign">*</span></label
                      >

                      <BInputGroup class="mt-3">
                        <template #append>
                          <BInputGroupText
                            style="font-size: 1.2rem"
                            @click="
                              showPass ? (showPass = false) : (showPass = true)
                            "
                            ><i
                              :class="
                                !showPass ? 'mdi mdi-eye-off' : 'mdi mdi-eye'
                              "
                            ></i>
                          </BInputGroupText>
                        </template>
                        <BFormInput
                          id="inline-form-input-name"
                          :type="showPass ? 'text' : 'password'"
                          v-model="reset_pass_form.usr_password"
                          class="form-control form-control-lg"
                          placeholder="Password"
                          :state="is_valid_user_pass"
                          aria-describedby="input_error_user_pass"
                          title="Must contain at least one number and one uppercase and lowercase letter, 
                            and at least 8 or more characters"
                          @change="onChangePass($event)"
                          minlength="8"
                          maxlength="100"
                        />
                      </BInputGroup>

                      <BFormInvalidFeedback
                        id="input_error_user_pass"
                        style="display: block"
                        v-if="is_valid_user_pass != null && !is_valid_user_pass"
                      >
                        Enter password
                      </BFormInvalidFeedback>
                    </div>

                    <div class="form-group">
                      <label for="exampleInputPassword4"
                        >Confirm Password<span class="mandatory-sign"
                          >*</span
                        ></label
                      >

                      <BInputGroup class="mt-3">
                        <template #append>
                          <BInputGroupText
                            style="font-size: 1.2rem"
                            @click="
                              showConfirmPass
                                ? (showConfirmPass = false)
                                : (showConfirmPass = true)
                            "
                            ><i
                              :class="
                                !showConfirmPass
                                  ? 'mdi mdi-eye-off'
                                  : 'mdi mdi-eye'
                              "
                            ></i>
                          </BInputGroupText>
                        </template>
                        <BFormInput
                          id="inline-form-input-name"
                          :type="showConfirmPass ? 'text' : 'password'"
                          v-model="reset_pass_form.usr_confirm_pass"
                          class="form-control form-control-lg"
                          placeholder="Password"
                          :state="is_valid_user_pass"
                          aria-describedby="input_error_user_pass"
                          title="Must contain at least one number and one uppercase and lowercase letter, 
                            and at least 8 or more characters"
                          @change="onChangePass($event)"
                          minlength="8"
                          maxlength="100"
                        />
                      </BInputGroup>

                      <BFormInvalidFeedback
                        id="input_error_user_confirm_pass"
                        style="display: block"
                        v-if="
                          confirm_pass_val_msg != null &&
                          !is_valid_user_confirm_pass
                        "
                      >
                        {{ confirm_pass_val_msg }}
                      </BFormInvalidFeedback>
                    </div>
                    <div>
                      <ul class="requirements">
                        <li
                          v-for="(requirement, key) in passwordRequirements"
                          :key="key"
                          :class="
                            requirement.predicate ? 'is-success' : 'is-error'
                          "
                        >
                          {{ requirement.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </BForm>
                <div class="mt-3">
                  <BButton
                    class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn"
                    type="submit"
                    >Reset
                  </BButton>

                  <BButton class="btn btn-light" type="button" @click="cancel"
                    >Cancel
                  </BButton>
                </div>
              </BForm>
            </div>
          </div>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref, onBeforeMount, computed } from "vue";
import axios from "axios";
import { toast } from "vue3-toastify";
import router from "@/router";
import { useAuthStore } from "@/store/auth_store";
import { AESEncryptData } from "@/utils/common-function";

const showPass = ref(false);
const showConfirmPass = ref(false);
const reset_pass_form = ref({
  usr_id: null,
  usr_password: "",
  usr_confirm_pass: "",
});

const is_valid_user_pass = ref(null);
const is_valid_user_confirm_pass = ref(null);
const confirm_pass_val_msg = ref(null);

const auth_store = useAuthStore();

const passwordRequirements = computed(() => [
  {
    name: "Must contain uppercase letters",
    predicate:
      reset_pass_form.value.usr_password.toLowerCase() !==
      reset_pass_form.value.usr_password,
  },
  {
    name: "Must contain lowercase letters",
    predicate:
      reset_pass_form.value.usr_password.toUpperCase() !==
      reset_pass_form.value.usr_password,
  },
  {
    name: "Must contain numbers",
    predicate: /\d/.test(reset_pass_form.value.usr_password),
  },
  {
    name: "Must contain symbols",
    predicate: /\W/.test(reset_pass_form.value.usr_password),
  },
  {
    name: "Must be at least 8 characters long",
    predicate: reset_pass_form.value.usr_password.length >= 8,
  },
  {
    name: "Must match Password and Confirm Password",
    predicate:
      reset_pass_form.value.usr_confirm_pass != "" &&
      reset_pass_form.value.usr_password ===
        reset_pass_form.value.usr_confirm_pass,
  },
]);

const validateResetPassForm = () => {
  is_valid_user_pass.value =
    reset_pass_form.value.usr_password == "" ? false : true;
  is_valid_user_confirm_pass.value =
    reset_pass_form.value.usr_confirm_pass == "" ? false : true;
  confirm_pass_val_msg.value =
    reset_pass_form.value.usr_confirm_pass == ""
      ? "Enter Confirm Password"
      : null;
  if (
    reset_pass_form.value.usr_confirm_pass != undefined &&
    reset_pass_form.value.usr_confirm_pass != null &&
    reset_pass_form.value.usr_confirm_pass.length > 0 &&
    reset_pass_form.value.usr_password !==
      reset_pass_form.value.usr_confirm_pass
  ) {
    is_valid_user_confirm_pass.value = false;
    confirm_pass_val_msg.value = "Password and confirm Password are mismatch";
  }

  if (
    !is_valid_user_pass.value ||
    !is_valid_user_confirm_pass.value ||
    passwordRequirements.value.find((u) => u.predicate == false) != null
  )
    return false;
  else return true;
};

onBeforeMount(() => {
  if (
    auth_store.reset_pass_user == undefined ||
    auth_store.reset_pass_user == null
  ) {
    router.push({ name: "login" });
  }
});

const resetPassword = () => {
  if (validateResetPassForm()) {
    reset_pass_form.value.usr_id = auth_store.reset_pass_user.usr_id;
    let pass = reset_pass_form.value.usr_password;
    reset_pass_form.value.usr_password = AESEncryptData(
      reset_pass_form.value.usr_password,
    );
    axios
      .post("/reset_user_pass", reset_pass_form.value)
      .then((res) => {
        if (
          res.data != undefined &&
          res.data.retVal != undefined &&
          res.data.retVal != null &&
          res.data.retVal == 1
        ) {
          reset_pass_form.value.usr_password = pass;
          toast(res.data.message, {
            autoClose: 2000,
            theme: "colored",
            type: "success",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });
          router.push({ name: "login" });

          //todo refresh the list
        }
      })
      .catch((err) => {
        reset_pass_form.value.usr_password = pass;
        if (
          err != undefined &&
          err != null &&
          err.response != undefined &&
          err.response != null &&
          err.response.data != undefined &&
          err.response.data != null
        ) {
          toast(err.response.data.detail, {
            autoClose: 2000,
            theme: "colored",
            type: "error",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });
        }
      });
  }
};

const onChangePass = (event) => {
  passwordRequirements,
    () => {
      passwordRequirements.value.reduce((v, p) => v && p.predicate, true);
    };
};

const cancel = () => {
  auth_store.reset_pass_user = null;
  router.push({ name: "login" });
};
</script>

<style scoped>
.requirements {
  font-weight: 400;
}

.is-success {
  color: #96ca2d;
}

.is-error {
  color: #ba3637;
}
</style>
